import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
      theme: {
        options: {
          customProperties: true,
        },
        themes: {
          light: {
            primary: '#cb1d15',
            secondary: '#9d1610',
            accent: '#9d1610',
            error: '#EC392E',
            info: '#006E9E',
            success: '#44AF69',
            warning: '#FCAB10',
            dark: '#1C1C1C',
            grey: '#666666',
            grey_2: '#7D7D7D'
          },

        },
      },
});
